import React from "react";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-grid"></div>
      <div className="hero-glow"></div>

      <div className="hero-content">
        <img src="/robot2.png" alt="Knights of the Ping Pong Table logo" />

        <div className="hero-eyebrow">
          FTC Team #19938 &mdash; FIRST Tech Challenge
        </div>

        <h1>
          Knights of the
          <br />
          <span>Ping Pong Table</span>
        </h1>

        <p className="hero-sub">
          Building robots, forging champions. A student-led FTC team driven by
          engineering, teamwork, and a little bit of ping pong along the way.
        </p>

        <div className="hero-btns">
          <a href="#about" className="btn">
            MEET THE KNIGHTS
          </a>
          <a
            href="https://www.youtube.com/@Ping-pongSocial/videos"
            className="btn btn-ghost"
            target="_blank"
            rel="noopener noreferrer"
          >
            YOUTUBE
          </a>
          <a href="#contact" className="btn btn-ghost">
            Get in Touch
          </a>
        </div>

        <h2>
          <br />
          2025 AWARDS
          <br />
          <span>1ST PLACE - DESIGN AWARD</span>
          <br />
          <span>2ND PLACE - REACH AWARD</span>
        </h2>

        <h2>
          2024 AWARDS
          <br />
          <span>2ND PLACE - CONNECT AWARD</span>
          <br />
          <span>3RD PLACE - DESIGN AWARD</span>
        </h2>
      </div>
    </section>
  );
};

export default Hero;
